module.exports = __webpack_public_path__ + "images/maarten_small95bb0f9dd01233171e9f9be0bc77f6fe.png";